import { SimulationServiceServiceException as __BaseException } from "../models/SimulationServiceServiceException";
import { BadRequest, InvalidCoordinates, InvalidState, NoSuchResource, ValidationException, } from "../models/models_0";
import { loadRestJsonErrorCode, parseJsonBody as parseBody, parseJsonErrorBody as parseErrorBody, } from "@aws-sdk/core";
import { requestBuilder as rb } from "@smithy/core";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectInt32 as __expectInt32, expectNonNull as __expectNonNull, expectObject as __expectObject, expectString as __expectString, limitedParseDouble as __limitedParseDouble, parseRfc3339DateTimeWithOffset as __parseRfc3339DateTimeWithOffset, serializeFloat as __serializeFloat, _json, collectBody, map, take, withBaseException, } from "@smithy/smithy-client";
export const se_CreateSimulationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/simulation/{uid}");
    b.p('uid', () => input.uid, '{uid}', false);
    let body;
    body = JSON.stringify(take(input, {
        'name': [],
        'parameters': _ => se_SimulationParameters(_, context),
        'zone': _ => se_GeoJSON(_, context),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_DeleteSimulationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/simulation/{uid}/{id}");
    b.p('uid', () => input.uid, '{uid}', false);
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetLocationDetailsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/location/{uid}");
    b.p('uid', () => input.uid, '{uid}', false);
    const query = map({
        [_l]: [__expectNonNull(input.lat, `lat`) != null, () => ((input[_l] % 1 == 0) ? input[_l] + ".0" : input[_l].toString())],
        [_lo]: [__expectNonNull(input.lon, `lon`) != null, () => ((input[_lo] % 1 == 0) ? input[_lo] + ".0" : input[_lo].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'parameters': _ => se_SimulationParameters(_, context),
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetLocationDetailsFromSimulationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/simulation/{uid}/{id}/location");
    b.p('uid', () => input.uid, '{uid}', false);
    b.p('id', () => input.id, '{id}', false);
    const query = map({
        [_l]: [__expectNonNull(input.lat, `lat`) != null, () => ((input[_l] % 1 == 0) ? input[_l] + ".0" : input[_l].toString())],
        [_lo]: [__expectNonNull(input.lon, `lon`) != null, () => ((input[_lo] % 1 == 0) ? input[_lo] + ".0" : input[_lo].toString())],
    });
    let body;
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetSimulationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/simulation/{uid}/{id}");
    b.p('uid', () => input.uid, '{uid}', false);
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetSimulationResultsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/simulation/{uid}/{id}/results");
    b.p('uid', () => input.uid, '{uid}', false);
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_ListSimulationsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/simulations/{uid}");
    b.p('uid', () => input.uid, '{uid}', false);
    const query = map({
        [_nT]: [, input[_nT]],
        [_pS]: [__expectNonNull(input.pageSize, `pageSize`) != null, () => input[_pS].toString()],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_RenameSimulationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/simulation/{uid}/{id}/rename");
    b.p('uid', () => input.uid, '{uid}', false);
    b.p('id', () => input.id, '{id}', false);
    let body;
    body = JSON.stringify(take(input, {
        'name': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_StartSimulationCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/simulation/{uid}/{id}/start");
    b.p('uid', () => input.uid, '{uid}', false);
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const de_CreateSimulationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'dates': _ => de_SimulationDate(_, context),
        'id': __expectString,
        'name': __expectString,
        'parameters': _ => de_SimulationParameters(_, context),
        'state': __expectString,
        'uid': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_DeleteSimulationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'dates': _ => de_SimulationDate(_, context),
        'id': __expectString,
        'name': __expectString,
        'parameters': _ => de_SimulationParameters(_, context),
        'state': __expectString,
        'uid': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetLocationDetailsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'average_capacity_factor': __limitedParseDouble,
        'complex_terrain': __expectBoolean,
        'country': __expectString,
        'csv': __expectString,
        'electricity_price': __limitedParseDouble,
        'electricity_ranking': __expectInt32,
        'ghi': __limitedParseDouble,
        'grid_connection_time': __expectInt32,
        'grid_distance': __limitedParseDouble,
        'lcoe': __limitedParseDouble,
        'mix': __limitedParseDouble,
        'slope': __limitedParseDouble,
        'solar_capacity_factor': __limitedParseDouble,
        'solar_capex': __limitedParseDouble,
        'solar_hourly_capacity_factor': _ => de_ValueList(_, context),
        'solar_monthly_capacity_factor': _ => de_ValueList(_, context),
        'solar_opex': __limitedParseDouble,
        'temperature': __limitedParseDouble,
        'wind_capacity_factor': __limitedParseDouble,
        'wind_capex': __limitedParseDouble,
        'wind_hourly_capacity_factor': _ => de_ValueList(_, context),
        'wind_monthly_capacity_factor': _ => de_ValueList(_, context),
        'wind_opex': __limitedParseDouble,
        'wind_speed': __limitedParseDouble,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetLocationDetailsFromSimulationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'average_capacity_factor': __limitedParseDouble,
        'complex_terrain': __expectBoolean,
        'country': __expectString,
        'csv': __expectString,
        'electricity_price': __limitedParseDouble,
        'electricity_ranking': __expectInt32,
        'ghi': __limitedParseDouble,
        'grid_connection_time': __expectInt32,
        'grid_distance': __limitedParseDouble,
        'lcoe': __limitedParseDouble,
        'mix': __limitedParseDouble,
        'slope': __limitedParseDouble,
        'solar_capacity_factor': __limitedParseDouble,
        'solar_capex': __limitedParseDouble,
        'solar_hourly_capacity_factor': _ => de_ValueList(_, context),
        'solar_monthly_capacity_factor': _ => de_ValueList(_, context),
        'solar_opex': __limitedParseDouble,
        'temperature': __limitedParseDouble,
        'wind_capacity_factor': __limitedParseDouble,
        'wind_capex': __limitedParseDouble,
        'wind_hourly_capacity_factor': _ => de_ValueList(_, context),
        'wind_monthly_capacity_factor': _ => de_ValueList(_, context),
        'wind_opex': __limitedParseDouble,
        'wind_speed': __limitedParseDouble,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetSimulationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'dates': _ => de_SimulationDate(_, context),
        'id': __expectString,
        'name': __expectString,
        'parameters': _ => de_SimulationParameters(_, context),
        'state': __expectString,
        'uid': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetSimulationResultsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'airports_layer': __expectString,
        'allkpis_heatmap': __expectString,
        'complex_heatmap': __expectString,
        'forest_layer': __expectString,
        'lcoe_heatmap': __expectString,
        'powerlines_layer': __expectString,
        'protected_areas_layer': __expectString,
        'urban_layer': __expectString,
        'water_layer': __expectString,
        'wetland_layer': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_ListSimulationsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'items': _ => de_SimulationsList(_, context),
        'nextToken': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_RenameSimulationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'dates': _ => de_SimulationDate(_, context),
        'id': __expectString,
        'name': __expectString,
        'parameters': _ => de_SimulationParameters(_, context),
        'state': __expectString,
        'uid': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_StartSimulationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'dates': _ => de_SimulationDate(_, context),
        'id': __expectString,
        'name': __expectString,
        'parameters': _ => de_SimulationParameters(_, context),
        'state': __expectString,
        'uid': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequest":
        case "wisogis.common#BadRequest":
            throw await de_BadRequestRes(parsedOutput, context);
        case "InvalidCoordinates":
        case "wisogis.common#InvalidCoordinates":
            throw await de_InvalidCoordinatesRes(parsedOutput, context);
        case "NoSuchResource":
        case "wisogis.common#NoSuchResource":
            throw await de_NoSuchResourceRes(parsedOutput, context);
        case "ValidationException":
        case "smithy.framework#ValidationException":
            throw await de_ValidationExceptionRes(parsedOutput, context);
        case "InvalidState":
        case "wisogis.common#InvalidState":
            throw await de_InvalidStateRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode
            });
    }
};
const throwDefaultError = withBaseException(__BaseException);
const de_ValidationExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'fieldList': _json,
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_BadRequestRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new BadRequest({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_InvalidCoordinatesRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'coord': _ => de_Coord(_, context),
    });
    Object.assign(contents, doc);
    const exception = new InvalidCoordinates({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_InvalidStateRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'stateExpected': _json,
        'stateFound': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new InvalidState({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_NoSuchResourceRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'resourceId': _ => de_ResourceId(_, context),
        'resourceType': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new NoSuchResource({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const se_GeoJSON = (input, context) => {
    return input;
};
const se_LayerParameters = (input, context) => {
    return take(input, {
        'airports': [],
        'complex_terrain': __serializeFloat,
        'forest': [],
        'power_lines': [],
        'protected_areas': [],
        'urban': [],
        'water': [],
        'wetland': [],
    });
};
const se_LcoeParameters = (input, context) => {
    return take(input, {
        'lifetime': __serializeFloat,
        'solar_capex': __serializeFloat,
        'solar_opex': __serializeFloat,
        'wacc': __serializeFloat,
        'wind_capex': __serializeFloat,
        'wind_opex': __serializeFloat,
    });
};
const se_SimulationParameters = (input, context) => {
    return take(input, {
        'combined': __serializeFloat,
        'grid_connection_type': [],
        'grid_cost_per_km': __serializeFloat,
        'layer_params': _ => se_LayerParameters(_, context),
        'lcoe_params': _ => se_LcoeParameters(_, context),
        'max_slope': __serializeFloat,
        'model_wt': [],
        'optimization': [],
        'pv_tracking': [],
        'slope_cost_per_percent': __serializeFloat,
    });
};
const de_Coord = (output, context) => {
    return take(output, {
        'lat': __limitedParseDouble,
        'lon': __limitedParseDouble,
    });
};
const de_ResourceId = (output, context) => {
    return output;
};
const de_ValueList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return __limitedParseDouble(entry);
    });
    return retVal;
};
const de_LayerParameters = (output, context) => {
    return take(output, {
        'airports': __expectInt32,
        'complex_terrain': __limitedParseDouble,
        'forest': __expectInt32,
        'power_lines': __expectInt32,
        'protected_areas': __expectInt32,
        'urban': __expectInt32,
        'water': __expectInt32,
        'wetland': __expectInt32,
    });
};
const de_LcoeParameters = (output, context) => {
    return take(output, {
        'lifetime': __limitedParseDouble,
        'solar_capex': __limitedParseDouble,
        'solar_opex': __limitedParseDouble,
        'wacc': __limitedParseDouble,
        'wind_capex': __limitedParseDouble,
        'wind_opex': __limitedParseDouble,
    });
};
const de_SimulationDate = (output, context) => {
    return take(output, {
        'computing': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'created': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'error': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'ready': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
    });
};
const de_SimulationItem = (output, context) => {
    return take(output, {
        'dates': (_) => de_SimulationDate(_, context),
        'id': __expectString,
        'name': __expectString,
        'parameters': (_) => de_SimulationParameters(_, context),
        'state': __expectString,
        'uid': __expectString,
    });
};
const de_SimulationParameters = (output, context) => {
    return take(output, {
        'combined': __limitedParseDouble,
        'grid_connection_type': __expectString,
        'grid_cost_per_km': __limitedParseDouble,
        'layer_params': (_) => de_LayerParameters(_, context),
        'lcoe_params': (_) => de_LcoeParameters(_, context),
        'max_slope': __limitedParseDouble,
        'model_wt': __expectString,
        'optimization': __expectString,
        'pv_tracking': __expectBoolean,
        'slope_cost_per_percent': __limitedParseDouble,
    });
};
const de_SimulationsList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_SimulationItem(entry, context);
    });
    return retVal;
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then(body => context.utf8Encoder(body));
const _l = "lat";
const _lo = "lon";
const _nT = "nextToken";
const _pS = "pageSize";
